<form [formGroup]="form">
  <ion-row>
    <ion-col size="2.75">
      <app-form-checkbox
        [label]="CONSTANTS.LABEL"
        (valueChanged)="updateValue($event)"
      >
      </app-form-checkbox
    ></ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="4">
      <div class="dropdown-container">
        <ng-select
          formControlName="ediDelayInterval"
          appearance="outline"
          [searchable]="false"
          [clearable]="false"
        >
          @for (option of OPTIONS; track option) {
            <ng-option [value]="option.value">
              <div class="option">
                {{ option.label }}
              </div>
            </ng-option>
          }
        </ng-select>
        <div class="text">{{ CONSTANTS.DROPDOWN_TEXT }}</div>
      </div>
    </ion-col>
  </ion-row>
</form>
